import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Network & Security Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><h2>Financial Sector Projects</h2></a>
                <p>Led the architectural design and implementation within Financial Sector network topology from 
ground zero across HQ Data Center, Disaster Recovery "(DR)" site, and all branch locations, 
delivering secure segmentation using VLANs, DMZ, WAN zoning, VPN and ZTNA, and deploying 
Layer 3 core switching, SD-WAN, and secure HCI virtualization backbones integrated with NGFW 
clustering (FortiGate & Sophos) to ensure secure isolation and high availability.</p>
            </div>
            <div className="project">
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><img src={mock09} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><h2>Financial Sector Projects</h2></a>
                <p>Led the design and integration of the Data Center enterprise Backup infrastructure Topology, 
connecting SAN storage systems with VEEAM Server and Sangfor HCI and VMware vSphere 
environments with Backup Server, and Tape Library backup solutions, with high availability, and 
optimal performance.</p>
            </div>
            <div className="project">
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><h2>Financial Sector Projects</h2></a>
                <p>Led the deployment and operational management of enterprise EDR/XDR platforms (Sophos 
Intercept X), strengthening endpoint threat detection, investigation, and automated response 
across critical banking systems and Endpoint.</p>
            </div>
            <div className="project">
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://qasemibank.com/" target="_blank" rel="noreferrer"><h2>Financial Sector Projects</h2></a>
                <p>Led the deployment of enterprise-grade Wi-Fi (UniFi), IP PBX systems (Grandstream), and 
endpoint security solutions across HQ and branch locations. </p>
            </div>
            <div className="project">
                <a href="https://ar-rasheed.edu.ye/" target="_blank" rel="noreferrer"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://ar-rasheed.edu.ye/" target="_blank" rel="noreferrer"><h2>Academic Sector IT Projects</h2></a>
                <p>Led the architectural design of the network topology Within the academic sector, including the 
Main campus network and the Disaster Recovery (DR) site, ensuring secure segmentation, 
redundancy, and failover capabilities. </p>
            </div>
            <div className="project">
                <a href="https://tawfeerhyper.com/" target="_blank" rel="noreferrer"><img src={mock05} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://tawfeerhyper.com/" target="_blank" rel="noreferrer"><h2>HyperMarket Sector IT & Security Projects</h2></a>
                <p>Led Migrated Physical infrastructure to VMware vSphere with HA and DRS. </p>
            </div>
            <div className="project">
                <a href="https://tawfeerhyper.com/" target="_blank" rel="noreferrer"><img src={mock04} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://tawfeerhyper.com/" target="_blank" rel="noreferrer"><h2>HyperMarket Sector IT & Security Projects</h2></a>
                <p>Led Replaced ASA with Sophos XG firewalls and implemented SD-WAN .</p>
            </div>
            <div className="project">
                <a href="https://tawfeerhyper.com/" target="_blank" rel="noreferrer"><img src={mock03} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://tawfeerhyper.com/" target="_blank" rel="noreferrer"><h2>HyperMarket Sector IT & Security Projects</h2></a>
                <p>deployment IP PBX systems (Grandstream), Kasper Sky endpoint security solutions across HQ and branch locations.</p>
            </div>
            <div className="project">
                <a href="https://www.facebook.com/fmfyemen/posts/pfbid02zyhBH5yuHxbbSMLUHas4PUSAvmLwfkKkEtsfVYWgMqucgbwKFqxn2HDQoxJvakcsl" target="_blank" rel="noreferrer"><img src={mock02} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/fmfyemen/posts/pfbid02zyhBH5yuHxbbSMLUHas4PUSAvmLwfkKkEtsfVYWgMqucgbwKFqxn2HDQoxJvakcsl" target="_blank" rel="noreferrer"><h2>Professional Training for Organizations</h2></a>
                <p>Provided hands-on technical training to various institutions and IT teams in Network Security, focusing on FortiGate NGFW firewall deployment, secure network design, FortiClient EMS & ZTNA, and real-world lab simulations using Cloud labs, PNETLab, GNS3, and EVE-NG frameworks.</p>
            </div>
            <div className="project">
                <a href="https://su-edu.net/" target="_blank" rel="noreferrer"><img src={mock01} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://iutt.edu.ye/" target="_blank" rel="noreferrer"><h2>Academic Teaching & Training</h2></a>
                <p>Taught Cloud Computing, Network Security (Firewalls), and Cybersecurity Fundamentals across multiple local universities using cloud environments and virtual labs with PNETLab, GNS3, and EVE-NG.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;